import { ref, type Ref } from 'vue';

export const loadedEnvelopeId: Ref<number | null> = ref(null);

